import * as React from "react";
import useMobileBreakpoint from "@src/hooks/useMobileBreakpoint";
import { useEffect, useLayoutEffect, useState } from "react";
import Grid from "./Layouts/Grid";
import Scrollable from "./Layouts/Scrollable";
import Carousel from "./Layouts/Carousel";
import "./MulticolumnNew.scss";

const layouts = {
  'grid': Grid,
  'none': Grid,
  'scrollable': Scrollable,
  'carousel': Carousel,
}

export const MulticolumnNew = ({
  settings,
  columns,
  headerText,
  subtext,
  tagline,
  columns_count,
  additional
}) => {
  let isMobile = useMobileBreakpoint("1024px");
  const [isLoaded, setIsLoaded] = useState(false);
  const layout = isMobile ?settings?.section.layout_mobile : settings?.section.layout;

  const LayoutComponent = layouts[layout] || Grid;
  let filteredColumns = columns;
  if (isMobile) {
    filteredColumns = columns.filter((column) => column.settings.render_type === 'all');
  }
  useEffect(() => {
    if (isMobile !== undefined) {
      setIsLoaded(true);
    }
  }, [isMobile]);

  if (!isLoaded) {
    return null;
  }

  if (settings.section.render_type !== "all") {
    if (isMobile && settings.section.render_type !== "mobile-only") return;
    if (!isMobile && settings.section.render_type !== "desktop-only") return;
  }

  const isNullOrEmpty = (value) => {
    if (Array.isArray(value)) {
      return value.length === 0 || value.some(item => !item?.title?.trim());
    }
    return value === null || value === undefined || (typeof value === 'string' && !value.trim());
  };

  if (settings.section.render_if_content) {
    const variablesToCheck = [
      ...settings.blocks.map(block => block.settings.title),
      ...settings.blocks.map(block => block.settings.content),
    ];

    const hasEmptyOrNull = variablesToCheck.some(isNullOrEmpty);

    if (hasEmptyOrNull) {
      return null;
    }
  }

  // Parse alt texts from additional (||-separated string)
  let imageAlts: string[] = [];
  if (typeof additional === "string") {
    imageAlts = additional.split("||").map(str => str.trim()).filter(Boolean);
  }

  return (
    <>
      <LayoutComponent
        settings={settings}
        columns={filteredColumns}
        headerText={headerText}
        subtext={subtext}
        tagline={tagline}
        columns_count={columns_count}
        additional={additional}
        imageAlts={imageAlts}
      />
    </>
  );
};

export default MulticolumnNew;